export default __webpack_public_path__ + "static/media/ExcitingEnergy_05.4533ab25.png";